export const PANNEAU_LC = 'panneauLc';
export const RESEAU_TEMPO = 'reseauTempo';
export const RESEAU_LC = 'reseauLc';
export const PANNEAU_NUMERIQUE = 'panneauNumerique';
export const RESEAU_NUMERIQUE = 'reseauNumerique';
export const RESEAU_PERSO = 'reseauPerso';



// WEBPACK FOOTER //
// ./src/configuration/typesProduits.js